function isIframedPage() {
  const isIframed = window !== window.parent;

  return isIframed;
}

export default isIframedPage;
